import React from "react";
import type {FunctionComponent} from "react";
import {useWhenSongDetailsLoadedWithLessonsLogic} from "./WhenSongDetailsLoadedWithLessons.logic";

export const WhenSongDetailsLoadedWithLessons: FunctionComponent = ({children}) => {
  const {isConditionPassed} = useWhenSongDetailsLoadedWithLessonsLogic();
  if (!isConditionPassed) {
    return null;
  }
  return <>{children}</>;
}
